import styled from 'styled-components';
import { FlexibleLinkComponent } from 'components/Links';

export const StyledLink = styled(FlexibleLinkComponent)`
  font-weight: ${props => props.theme.fontWeight.bold};
  text-decoration: none;
`;
